export enum ExportErrorsTabsEnum {
    COMPANY_ERRORS = 'company',
    CONTACT_ERRORS = 'contact',
    CONTENT_ERRORS = 'content',
}
